import { useEffect, useState } from "react";
import OrderScheduleModal from "../components/modals/OrderScheduleModal";
import OrderCancelModal from "../components/features/orders/OrderCancelModel";
import ReturnsScheduleModal from "../components/modals/ReturnsScheduleModal";
import ReturnsCancelModal from "../components/features/returns/ReturnsCancelModel";

import OtpModal from "../components/ui/OtpModal";
import AddProfileModal from "../components/features/setUp/AddProfileModal";

const ModalProvider = () => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    return null;
  }
  return (
    <>
      <OrderScheduleModal />
      <OrderCancelModal />
      <ReturnsScheduleModal />
      <ReturnsCancelModal />
      <OtpModal />
      <AddProfileModal />
    </>
  );
};

export default ModalProvider;
